class mySql {
    constructor(){

    }
    /*
        功能：根据连接字串获取默认数据库
        connectString ： 连接字串
    */
    getDefaultDataBase(connectString){
        return connectString.match(/Initial Catalog=([^;]*);/)[1];
    }
    /*
        功能：格式化sql语句
        sql ： 连接字串
    */
    FilterSQL(sql){
        return sql;
    }
}
export default new mySql();


// WEBPACK FOOTER //
// ./src/js/backstage/fvADOModule/lib/mySql.js